import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useRef } from 'react';
import {
  FormGroup, FormControlLabel, Checkbox, Typography, FormControl, MenuItem, InputLabel, Select,
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from '../../../GlobalFunction/checkAndLock';
import UnLock from '../../../GlobalFunction/UnLock';
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import axiosInstance from '../../../lib/axios';
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../atoms/ReportFolder/ReportTable";

// Define columns for the print table
const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "UnitName", label: "Unit Name", minWidth: 100 },
  { id: "UnitAbrv", label: "Abbreviation", minWidth: 50 },
  { id: "UnitFor", label: "Unit For", minWidth: 50 },
  { id: "Remark", label: "Remark", minWidth: 100 },
  { id: "Status", label: "Status", minWidth: 50 },
];

const UnitMaster = () => {
  const { register, setValue, reset, watch } = useForm();
  const [UserId] = useState(sessionStorage.getItem('UserId'));
  const [UnitId, setUnitId] = useState(-1);
  const [Mode, setMode] = useState("add");
  const [TransactionData, setTransactionData] = useState([]);
  const [OpenDForDelete, setOpenDForDelete] = useState(false);
  const [AllDisUnable, setAllDisUnable] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  // Printing related states and refs
  const contentRef = useRef(null);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const handlePrint = useReactToPrint({ contentRef });

  useEffect(() => {
    const fetchData = async () => {
      await fetchDashboardData(); // Fetch data for printing
      if (location.state) {
        setAllDisUnable(false);
        let unitid = location.state.UnitId;
        setUnitId(unitid);
        await fetchTransactionData(unitid, "R");
      } else {
        setMode("add");
        setAllDisUnable(true);
      }
    }

    fetchData();
  }, [location.state]);

  // Fetch dashboard data for printing
  const fetchDashboardData = async () => {
    try {
      const res = await axiosInstance.post("MstUnit/GetMstUnitDashBoard", {
        start: 4,
        PageSize: 0,
        SearchText: "",
      });
      if (res.data && res.data.Data) {
        setRows(res.data.Data);
        setDataForPrint(res.data.Data);
      } else {
        setRows([]);
        setDataForPrint({});
      }
    } catch (err) {
      toast.error("Error fetching dashboard data");
    }
  };

  useEffect(() => {
    if (TransactionData.length > 0 && Mode !== "add") {
      const obj = watch();
      for (let key in obj) {
        if (TransactionData[0].hasOwnProperty(key)) {
          setValue(key, TransactionData[0][key]);
        } else {
          setValue(key, "");
        }
      }
      setAllDisUnable(false);
    } else if (Mode === "add") {
      handleAddClick();
    }
  }, [TransactionData, Mode]);

  const fetchTransactionData = async (UnitId, Flag) => {
    try {
      const response = await axiosInstance.post(`MstUnit/RetriveMstUnit`, {
        UnitId,
        Flag
      });

      if (response.data.Status === 0) {
        if (Flag === "D") {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(UnitId, "L");
          return;
        }
        let Data = response.data.Data != null ? response.data.Data : [];
        setTransactionData(Data);
        setUnitId(response.data.Data[0].UnitId);
        setMode("view");
      } else {
        if (Flag !== "D") {
          setUnitId(-1);
          Mode === "view" ? setMode("add") : handleAddClick();
        }
        toast.info(response.data.Message);
      }
    } catch (error) {
      console.error('Error fetching Transaction data:', error);
    }
  }

  const handleAddClick = () => {
    setMode("add");
    setAllDisUnable(true);
    resetFunc();
  }

  const handleEditClick = async () => {
    let Flag = await checkAndLock(UnitId, "MstUnit", "UnitId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setAllDisUnable(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  }

  const handleCancelDButton = () => {
    setOpenDForDelete(false);
  }

  const handleSubmitClick = async () => {
    const Obj = watch();
    if (watch("UnitName") === "" || watch("UnitFor") === "") {
      toast.info("Please Fill Required Field!");
      return;
    }

    let Payload = {
      "UnitName": watch("UnitName"),
      "UnitAbrv": watch("UnitAbrv"),
      "UnitFor": watch("UnitFor"),
      "Remark": watch("Remark"),
      "Status": watch("Status"),
      CreatedBy: parseInt(UserId)
    }

    if (Mode === "add") {
      try {
        const response = await axiosInstance.post(`MstUnit/InsertMstUnit`,
          Payload
        );

        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(response.data.Data, "R");
          setMode("view");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error('Error getting To Insert:', error);
      }
    } else {
      Payload = { ...Payload, UnitId, UpdatedBy: parseInt(UserId) };
      delete Payload.CreatedBy;

      try {
        const response = await axiosInstance.post(`MstUnit/UpdateMstUnit`,
          Payload
        );

        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          await UnLock(UnitId, "MstUnit", "UnitId");
          fetchTransactionData(UnitId, "R");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error('Error getting To Insert:', error);
      }
    }
  }

  const handleCancelClick = async () => {
    if (UnitId === -1 && Mode === "add") {
      await fetchTransactionData(1, "L")
    } else {
      await UnLock(UnitId, "MstUnit", "UnitId");
      await fetchTransactionData(UnitId, "R")
    }
  }

  const handleDeleteClick = () => {
    setOpenDForDelete(true);
  };

  const handleClickBackToTable = () => {
    navigate('/unittable')
  };

  const handleConfirmDDelete = () => {
    fetchTransactionData(UnitId, "D");
    setOpenDForDelete(false);
  };

  const handleNextClick = () => {
    fetchTransactionData(UnitId, "N");
  };

  const handlePrevClick = () => {
    fetchTransactionData(UnitId, "P");
  };

  const resetFunc = () => {
    reset({
      "UnitName": "",
      "UnitAbrv": "",
      "UnitFor": "",
      "Remark": "",
      "Status": "1",
    })
  };

  const handleCheckBoxChange = (e) => {
    if (watch("Status") === "1") {
      setValue("Status", "0");
    } else {
      setValue("Status", "1");
    }
  };

  return (
    <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
      <Dialog
        open={OpenDForDelete}
        onClose={handleCancelDButton}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Do You Want To Delete The Unit ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCancelDButton}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
      <Grid container spacing={2} className='form_grid'>
        <Grid item xs={12} className='form_title'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: '20px',
            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
          }}
        >
          <Grid
            sx={{
              display: 'flex',
              justifyContent: { xs: 'center', sm: 'flex-start' },
              marginBottom: { xs: '10px', sm: 0 }
            }}
          >
            <Button
              variant="contained"
              size="small"
              className='three-d-button-previous'
              sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
              onClick={handlePrevClick}
              disabled={AllDisUnable}
            >
              <KeyboardArrowLeftIcon />
            </Button>

            <Button
              variant="contained"
              size="small"
              className='three-d-button-next'
              sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
              onClick={handleNextClick}
              disabled={AllDisUnable}
            >
              <NavigateNextIcon />
            </Button>
          </Grid>

          <Typography
            variant="h5"
            sx={{
              margin: 'Auto',
              textAlign: { xs: 'center', sm: 'center' },
              fontSize: { xs: '24px', sm: '18px', md: '24px' }
            }}
          >
            Unit Master
          </Typography>

          <Grid sx={{ display: "flex", justifyContent: "end" }}>
            <CrudButtons
              moduleName="Unit Master"
              mode={Mode}
              onAdd={handleAddClick}
              onEdit={handleEditClick}
              onView={handlePrint}
              onDelete={handleDeleteClick}
              onExit={handleClickBackToTable}
              readOnlyMode={!AllDisUnable}
              onPrevious={handlePrevClick}
              onNext={handleNextClick}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={10} className='form_field' sx={{ marginX: "auto" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={5}>
              <TextField
                id="UnitName"
                name="UnitName"
                label={
                  <span>
                    Unit Name <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                value={watch('UnitName') || ''}
                {...register("UnitName")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <FormControl variant="filled" fullWidth className="custom-select">
                <InputLabel id="companyName-select-label">
                  <span>
                    Unit For <span style={{ color: "red" }}>*</span>
                  </span>
                </InputLabel>
                <Select
                  labelId="companyName-select-label"
                  id="UnitFor"
                  name="UnitFor"
                  className="custom-textfield"
                  value={watch('UnitFor') || ''}
                  {...register("UnitFor")}
                  disabled={!AllDisUnable}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200,
                        overflow: "auto",
                      },
                    },
                  }}
                >
                  <MenuItem key="N" value="N">
                    Number
                  </MenuItem>
                  <MenuItem key="L" value="L">
                    Length
                  </MenuItem>
                  <MenuItem key="W" value="W">
                    Weight
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                id="UnitAbrv"
                name="UnitAbrv"
                label="Abrv"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch('UnitAbrv') || ''}
                {...register("UnitAbrv")}
                disabled={!AllDisUnable}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                id="Remark"
                name="Remark"
                label="Remark"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch('Remark') || ''}
                {...register("Remark")}
                disabled={!AllDisUnable}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!AllDisUnable}
                      name="Status"
                      checked={watch("Status") === "1"}
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Status"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className="form_button">
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: 'linear-gradient(290deg, #d4d4d4, #ffffff)',
            }}
            onClick={handleSubmitClick}
            disabled={!AllDisUnable}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: 'linear-gradient(290deg, #a7c5e9, #ffffff)',
            }}
            onClick={handleCancelClick}
            disabled={!AllDisUnable}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>

      {/* Hidden Print Section */}
      <div style={{ display: "none" }}>
        {Object.keys(DataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Unit Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
    </Box>
  )
}

export default UnitMaster;